import { useCallback, useEffect, useState } from 'react';
import { SliderNavigationButton } from '@/src/shared/components/SliderNavigationButton';
import type { CarouselApi } from './types';

export interface ArrowsProps {
  classes?: {
    next?: string;
    prev?: string;
    disabled?: string;
  };
  iconColor?: string;
  iconSize?: number;
  carouselApi: CarouselApi;
  onNext?(): void;
  onPrev?(): void;
}

export const Arrows = ({ classes, carouselApi, ...rest }: ArrowsProps) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const scrollPrev = useCallback(() => {
    const apiInstance = carouselApi;
    if (apiInstance) apiInstance.scrollPrev();
    if (rest.onPrev) rest.onPrev();
  }, [carouselApi]);

  const scrollNext = useCallback(() => {
    const apiInstance = carouselApi;
    if (apiInstance) apiInstance.scrollNext();
    if (rest.onNext) rest.onNext();
  }, [carouselApi]);

  useEffect(() => {
    const apiInstance = carouselApi;

    const updateStates = (emblaApi: CarouselApi) => {
      setPrevBtnDisabled(!(emblaApi?.canScrollPrev() ?? false));
      setNextBtnDisabled(!(emblaApi?.canScrollNext() ?? false));
    };

    updateStates(apiInstance);

    // Setup event listeners
    if (apiInstance) {
      apiInstance.on('init', updateStates);
      apiInstance.on('reInit', updateStates);
      apiInstance.on('select', updateStates);

      return () => {
        apiInstance.off('reInit', updateStates);
        apiInstance.off('select', updateStates);
      };
    }
  }, [carouselApi]);

  if (nextBtnDisabled && prevBtnDisabled) return null;

  return (
    <>
      <SliderNavigationButton
        disabled={nextBtnDisabled}
        className={classes?.next}
        classes={{ disabled: classes?.disabled }}
        variant="next"
        onClick={scrollNext}
        {...rest}
      />
      <SliderNavigationButton
        disabled={prevBtnDisabled}
        className={classes?.prev}
        classes={{ disabled: classes?.disabled }}
        variant="prev"
        onClick={scrollPrev}
        {...rest}
      />
    </>
  );
};
